import axios from 'axios';

export const LMS = `${process.env.REACT_APP_BACKEND_URL}/api/lms`;

export const getStudentToken = () => localStorage.getItem('lms_token');
export const getStudent = () => {
  try { return JSON.parse(localStorage.getItem('lms_student') || 'null'); } catch { return null; }
};
export const setSession = (token, student) => {
  localStorage.setItem('lms_token', token);
  localStorage.setItem('lms_student', JSON.stringify(student));
};
export const clearSession = () => {
  localStorage.removeItem('lms_token');
  localStorage.removeItem('lms_student');
};

export const authHeaders = () => {
  const t = getStudentToken();
  const a = localStorage.getItem('admin_token');
  return { ...(t ? { Authorization: `Bearer ${t}` } : {}), ...(a ? { 'X-Admin-Token': a } : {}) };
};
export const adminPreviewHeaders = () => {
  const a = localStorage.getItem('admin_token');
  return a ? { 'X-Admin-Token': a } : {};
};

export const registerStudent = async (email, password, name) => {
  const { data } = await axios.post(`${LMS}/auth/register`, { email, password, name });
  setSession(data.token, data.student);
  return data.student;
};
export const loginStudent = async (email, password) => {
  const { data } = await axios.post(`${LMS}/auth/login`, { email, password });
  setSession(data.token, data.student);
  return data.student;
};

export const apiErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || '').join(' ');
  return e?.message || 'Something went wrong';
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = () => {
  const redirectUrl = window.location.origin + window.location.pathname;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
export const exchangeGoogleSession = async (sessionId) => {
  const { data } = await axios.post(`${LMS}/auth/google`, { session_id: sessionId });
  setSession(data.token, data.student);
  return data.student;
};

export const startCheckout = async (kind, courseId = '') => {
  const code = kind === 'review' ? '' : (sessionStorage.getItem('bc_discount_code') || '');
  const { data } = await axios.post(`${LMS}/checkout`, { kind, course_id: courseId, origin_url: window.location.origin, code }, { headers: authHeaders() });
  window.location.href = data.url;
};

export const audioSrc = (url) => (url && url.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL}${url}${url.includes('?') ? '&' : '?'}token=${encodeURIComponent(getStudentToken() || '')}` : url);

export const downloadTakeaway = async (courseId, t) => {
  const r = await axios.get(`${LMS}/courses/${courseId}/takeaways/${t.id}`, { headers: authHeaders(), responseType: 'blob' });
  const href = URL.createObjectURL(r.data);
  const a = document.createElement('a');
  a.href = href;
  a.download = `${t.title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}.${t.format}`;
  a.click();
  URL.revokeObjectURL(href);
};

export const certPdfUrl = (id) => `${LMS}/certificates/${id}/pdf`;
export const certPageImageUrl = (id) => `${LMS}/certificates/${id}/image.png?variant=page`;

export const certShareUrl = (id) => `${LMS}/certificates/${id}/share`;
export const certImageUrl = (id) => `${LMS}/certificates/${id}/image.png`;
export const linkedInShareUrl = (id) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(certShareUrl(id))}`;
export const linkedInAddUrl = (c) => {
  const d = new Date(c.issued_at);
  const q = new URLSearchParams({ startTask: 'CERTIFICATION_NAME', name: c.course_title, organizationName: 'Blue Cactus Digital', issueYear: String(d.getFullYear()), issueMonth: String(d.getMonth() + 1), certUrl: `${window.location.origin}/certificates/${c.id}`, certId: c.id });
  return `https://www.linkedin.com/profile/add?${q.toString()}`;
};
